namespace RS.ExternalHelp
{
    /**
     * Removes buyPass lines if not supported
     */
    export class BuyPassRTPPlugin extends RS.ExternalHelp.VisitorPlugin
    {
        private _buyPassRTP: string;
        private _buyPassMinRTP: string;
        private _buyPassMaxRTP: string;

        public constructor(page: RS.ExternalHelp.IPage)
        {
            super(page);
            this._buyPassRTP = RS.URL.getParameter("buypassRTP");
            this._buyPassMinRTP = RS.URL.getParameter("buypassMinRTP");
            this._buyPassMaxRTP = RS.URL.getParameter("buypassMaxRTP");
        }

        public onElementLoaded(element: HTMLElement)
        {
            const eID = element.id;
            if (eID == "rs-buyPassRTP")
            {
                element.innerHTML = element.innerHTML.replace("{RTP}", this._buyPassRTP);
            }
            else if (eID == "rs-buyPassMultiRTP")
            {
                element.innerHTML = element.innerHTML.replace("{minRTP}", this._buyPassMinRTP);
                element.innerHTML = element.innerHTML.replace("{maxRTP}", this._buyPassMaxRTP);
            }
        }
    }
    RS.ExternalHelp.pluginRegistry.register(BuyPassRTPPlugin);
}